export default __webpack_public_path__ + "e57c85e563871668223b297f97837b32.png";